module.exports = __webpack_public_path__ + "static/media/Sandaru.39685882.jpg";